module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust2.0a1f4891f4962aa4a9ba93cc65fc0b9d.png";